export default {"src":"/_next/static/media/watering-plant.mono.d2521332.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};